export const USER_DEFINED_SCENARIO = 'User defined scenario';
export const REF = 'REF';
export const REFERENCE = 'Reference';
export const WEM = 'WEM';
